import {
  CLOSE_DESIGNER_SIDEBAR,
  OPEN_DESIGNER_SIDEBAR,
  SET_ADDITIONAL_DESIGNER_DATA,
  SET_EDIT_ROW_MAIN_DATA,
  SET_EDIT_ROW_SECTIONS_MODAL_STATE,
  RESET_EDIT_ROW_FORM,
  SET_MOUSE_COORDS,
  SET_DND_SECTION_ID,
  UPDATE_CURRENT_LAYOUT,
  SET_PARENT_REFS,
  UPDATE_CURRENT_LAYOUT_LIST,
  RESET_DND_SECTION_ID,
  ADD_TO_UNRELATED_FIELDS,
  REMOVE_FROM_UNRELATED_FIELDS,
  ADD_NEW_SECTION,
  SET_ADD_NEW_SECTION_MODAL_STATE,
  MOVE_ITEM_TO_SECTION,
  DELETE_SECTION,
  SET_SEARCH_VALUE,
  SET_SECTION_REORDER_MODAL_STATE,
  SAVE_SECTIONS_ORDERING,
  SET_CUSTOMISATION_MODAL_STATE,
  UPDATE_SECTION,
  UPDATE_UNRELATED_FIELDS,
  REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS,
  UPDATE_MODEL,
  UPDATE_DATA_IN_EDIT_MODE,
} from './mutation-types';
import {uuid} from 'vue-uuid';
import {axiosClient} from '@/core/services/http.service';


export const getMainDesignerData = async ({state, commit}, payload) => {
  if (!payload) {

    const template = {
      ModalWidth: '80%',
      ModalHeight: '80%',
      Sections: [],
    };
    commit(SET_EDIT_ROW_MAIN_DATA, {
      mainData: template,
      relatedFields: null,
      placeholders: [],
    });
  } else {
    const parsedData = JSON.parse(payload);
    const relatedFields = [];
    const mainData = [];
    const placeholders = [];

    for (const el in parsedData) {
      const currentItem = parsedData[el];
      if (Array.isArray(currentItem)) {
        currentItem.forEach(el => {
          const id = uuid.v4();
          if (el.Placeholder) {
            placeholders.push(id);
          }
          const fields = el.Fields.map(item => {
            relatedFields.push(item.fieldGuid.toLowerCase());

            return {
              fieldGuid: item.fieldGuid,
              x: item.row,
              y: item.column,
              w: item.width,
              h: item.height,
              moved: item.moved,
              i: item.index,
            };
          }).sort((a, b) => b.y - a.y); // sorting section fields from bottom to top row, as vue-grid assigns z-index by order it got fields
          el.Fields = fields;
          mainData.push({
            ...el,
            id,

            Name: el.Placeholder
              ? `Placeholder ${placeholders.findIndex(i => i === id) + 1}`
              : el.Name,
          });
        });
      }
    }

    parsedData.Sections = mainData;
    commit(SET_EDIT_ROW_MAIN_DATA, {
      mainData: parsedData,
      relatedFields,
      placeholders,
    });
  }
};

export const getAdditionalInfoAboutDesignerFields = ({state, commit}, payload) => {
  const fields = {};
  const unrelatedFields = [];
  const form = payload.reduce((acc, el) => {
    if (el.isPrimaryKey) {
      state.primaryKey = el.name;
    }
    if (!el.isInternal) {
      if (state.relatedFields && !state.relatedFields.includes(el.fieldGuid)) {
        unrelatedFields.push(el);
      }
      acc[el.name] = el.dataTypeName === 'boolean' ? false : null;
      fields[el.fieldGuid] = el;
    }
    return acc;
  }, {});
  if (!state.data) return;
  if (!state.data.Sections.length) {
    commit(SET_ADDITIONAL_DESIGNER_DATA, {form, fields, unrelatedFields: Object.values(fields)});
  } else {
    commit(SET_ADDITIONAL_DESIGNER_DATA, {form, fields, unrelatedFields});
  }
};

export const openDesignerSidebar = ({commit}) => {
  commit(OPEN_DESIGNER_SIDEBAR);
};

export const closeDesignerSidebar = ({commit}) => {
  commit(CLOSE_DESIGNER_SIDEBAR);
}; 

export const setEditRowSectionsModalState = ({commit}, payload) => {
  commit(SET_EDIT_ROW_SECTIONS_MODAL_STATE, payload);
};

export const resetEditRowForm = ({commit}, payload) => {
  commit(RESET_EDIT_ROW_FORM, payload);
};

export const setMouseCoords = ({commit}, payload) => {
  commit(SET_MOUSE_COORDS, payload);
};
export const setDndSectionId = ({commit}, uuid) => {
  commit(SET_DND_SECTION_ID, uuid);
};

export const updateCurrentLayout = ({commit}, payload) => {
  commit(UPDATE_CURRENT_LAYOUT, payload);
};

export const updateCurrentLayoutList = ({commit}, payload) => {
  commit(UPDATE_CURRENT_LAYOUT_LIST, payload);
};
export const setParentRefs = ({commit}, payload) => {
  commit(SET_PARENT_REFS, payload);
};

export const resetDndSectionId = ({commit}) => {
  commit(RESET_DND_SECTION_ID);
};

export const addToUnrelatedFields = ({commit}, payload) => {
  commit(ADD_TO_UNRELATED_FIELDS, payload);
};

export const removeFromUnrelatedFields = ({commit}, uuid) => {
  commit(REMOVE_FROM_UNRELATED_FIELDS, uuid);
};

export const addNewSection = ({commit}, sectionName) => {
  commit(ADD_NEW_SECTION, sectionName);
};

export const setAddNewSectionModalState = ({commit}, payload) => {
  commit(SET_ADD_NEW_SECTION_MODAL_STATE, payload);
};

export const moveItemToAnotherSection = ({commit}, payload) => {
  commit(MOVE_ITEM_TO_SECTION, payload);
};

export const deleteSectionFromList = ({commit}, uuid) => {
  commit(DELETE_SECTION, uuid);
};

export const updateSection = ({commit}, payload) => {
  commit(UPDATE_SECTION, payload);
};

export const setSectionReorderModalState = ({commit}, payload) => {
  commit(SET_SECTION_REORDER_MODAL_STATE, payload);
};

export const saveSectionsOrdering = ({commit}, payload) => {
  const res = payload.sort((a, b) => a.y - b.y);
  commit(SAVE_SECTIONS_ORDERING, res);
};

export const setCustomisationModalState = ({commit}, payload) => {
  commit(SET_CUSTOMISATION_MODAL_STATE, payload);
};

export const setSearchValue = ({commit}, val) => {
  commit(SET_SEARCH_VALUE, val);
};

export const saveDesignerTabState = async ({state}, {uuid, isSubmit}) => {
  const res = state.data.Sections.map(section => {
    const Fields = section.Fields.map(field => ({
      fieldGuid: field.fieldGuid,
      moved: field.moved,
      row: field.x,
      column: field.y,
      width: field.w,
      height: field.h,
      index: field.i,
    }));
    return {...section, Fields};
  });
  const finalData = {
    ...state.data,
    Sections: res,
  };
  if(isSubmit) {
    return JSON.stringify(finalData) ;
  }
  const data = JSON.stringify(finalData, null, 2)
    .replace(/\n/g, '\\r\\n')
    .replace(/"/g, '\\"');

  await axiosClient.put(`/api/entity/add-edit-row-sections/${uuid}/`, `"${data}"`, {
    headers: {'Content-Type': 'application/json'},
  });
};

export const updateUnrelatedFields = ({commit}, payload) => {
  commit(UPDATE_UNRELATED_FIELDS, payload);
};

export  const removePostedStatusFromRelatedFields = ({commit}) => {
  commit(REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS);
};

export const updateModel = ({commit}, payload) => {
  commit(UPDATE_MODEL, payload);
};

export const updateDataInEditMode = ({commit}, payload) => {
  commit(UPDATE_DATA_IN_EDIT_MODE, payload);
};